'use strict';

module.exports = function validMeridian(value) {
	if (!value) {
		return false;
	}

	value = value.toUpperCase();

	return value == 'AM' || value == 'PM';
};


//////////////////
// WEBPACK FOOTER
// ./~/react-time-picker/lib/getFormat/validMeridian.js
// module id = 579
// module chunks = 0